import React from "react";
import { Avatar, ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { SITEWEB_SERVER_BASE_URL } from "../../util/apiClient";
import MenuApp from "./MenuApp";


const Liste = () => {

  const { filteredBannieres } = useSelector((state: IReduxState) => state.siteWeb);

  return (
      <div
        style={{
          padding: 10,
          height: "55vh",
          overflow: "auto",
        }}
      >
        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <List dense={true}>
            {filteredBannieres.map((item, i: number) => {
              return (
                <div key={i}>
                  <ListItem
                    secondaryAction={
                      <MenuApp
                        item={item}
                      />
                    }
                  >
                    <ListItem>
                      <ListItemIcon>
                        <Avatar alt="Pas d'image" src={`${SITEWEB_SERVER_BASE_URL}/bannerImages/${item?.libBanniere}`} />
                      </ListItemIcon>
                      <ListItemButton>
                        <ListItemText
                          secondary={
                            <Box style={{ display: "flex", flexDirection: "column" }}>
                              <Typography variant="caption">
                                {
                                  `${item.active === 0 ? "Activée" : "désactivée"}`
                                }
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </Box>
      </div>
  );
};
export default Liste;
